// Sender (your business) profile shown on invoices. Mirrors Android's
// SenderProfile (stored in DataStore there; localStorage here). Fields are all
// optional — empty ones are simply omitted from the PDF.

const SENDER_PROFILE_KEY = "invoice_sender_profile";

const EMPTY = {
  name: "",
  address: "",
  phone: "",
  bankSwift: "",
  bankName: "",
  bankAddress: "",
  accountNumber: "",
  beneficiaryName: "",
};

export function getSenderProfile() {
  try {
    const raw = localStorage.getItem(SENDER_PROFILE_KEY);
    return raw ? { ...EMPTY, ...JSON.parse(raw) } : { ...EMPTY };
  } catch (e) {
    return { ...EMPTY };
  }
}

export function setSenderProfile(profile) {
  try {
    localStorage.setItem(SENDER_PROFILE_KEY, JSON.stringify({ ...EMPTY, ...profile }));
  } catch (e) {
    /* ignore */
  }
}
